var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-field',{attrs:{"name":_vm.field.name}},[_c('black-pins',_vm._b({model:{value:(_vm.field.value),callback:function ($$v) {_vm.$set(_vm.field, "value", $$v)},expression:"field.value"}},'black-pins',_vm.field.props,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }